import { isNone, isEmpty } from '@ember/utils';
import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
import VisibilityState from '@square/dashboard-items-data/models/visibility-state';
export default ItemsV3Serializer.extend({
  keyForRelationship(key, type) {
    if (key === 'itemModifierList') {
      return 'modifier_list_id';
    }
    return this._super(key, type);
  },
  normalize(type, data) {
    // To default visibility, minSelectedModifiers, and maxSelectedModifiers without incurring dirty
    // checks, we need to alter the data here before loading if these attributes have no values initially
    if (!isNone(data)) {
      if (isNone(data.visibility)) {
        data.visibility = VisibilityState.PUBLIC;
      }
      if (isNone(data.enabled)) {
        data.enabled = true;
      }
      // a null value will override the fragment array, causing it to not initialize to an empty array correctly.
      if (isNone(data.item_modifier_option_overrides)) {
        delete data.item_modifier_option_overrides;
      }
    }
    return this._super(type, data);
  },
  serialize(snapshot) {
    const json = this._super(snapshot, {
      includeId: true
    });
    if (isEmpty(json.item_modifier_option_overrides)) {
      delete json.item_modifier_option_overrides;
    }
    return json;
  }
});